import api from "./api";
import qsStringify from "./qsStringify";

export const getTAList = (locale, queries) => {
  const query = qsStringify({
    populate: ["thumbnail", "categories.sort", "attachment.file"],
    sort: ["datetime:desc"],
    ...queries,
  });
  return api
    .get(`/tenders-and-auctions?locale=${locale}&${query}`)
    .then(res => res.data);
};
